<template>
    <div class="row m-b-xs  template-alert">

        <div class="col-md-3" :class="hasError('email') ? 'has-error' : ''">
            <label v-if="index == 0">{{ __('alarm_inform_to') }}</label>
            <input type="email" class="form-control" v-model="mailLocal" name="email[]" :readonly="blocked">
            <span class="help-block text-danger" v-if="hasError('email')">
            {{ getError('email') }}
            </span>
        </div>

        <div class="col" :class="hasError('types') ? 'has-error' : ''">
            <strong v-if="index == 0">{{__('alarm_category')}}</strong>
            <select :class="{ s2: true, 'form-control': true }" multiple="multiple" :name="'types[' + (index) + '][]'"
                    >
                <option v-for="(key, value) in categories" :value="value"
                        :selected="notification!=null ? notification.includes(value) : false">{{ key }}
                </option>
            </select>

            <span class="help-block text-danger" v-if="hasError('types')">
            {{ getError('types') }}
             </span>

        </div>
        <div class="max-w-20 m-auto col table-icons p-0">
            <a href="javascript:;" data-toggle="tooltip" data-placement="top"
               title="" data-original-title="Usuń" @click="$emit('destroy-contact', index, email)"><i
                class="fa fa-trash "></i></a>
        </div>

    </div>
</template>

<script>
export default {
    name: "ServiceAlertContact",
    props: {
        categories: {
            type: Object,
            required: true,
        },
        index: {
            type: Number,
            required: true,
        },
        email: {
            type: String,
            required: false,
        },
        notification: {
            type: Array,
            required: false,
        },
        blocked: {
            type: Boolean,
            default: false,
        },
        errors: {
            type: Object,
            required: false,
        },
        originalCount: {
            type: Number,
            default: 0,
        }
    },
    data() {
        return {
            mailLocal: this.email,
        }
    },

    methods: {
        hasError(inputName) {
            if (inputName !== 'types') {
                if(this.errors[`${inputName}`][`${'email'}.${this.index}`] === undefined){
                    return false;
                }
                return this.errors[`${inputName}`][`${inputName}.${this.index}`] !== undefined
            } else {
                let findIn = this.errors.types[0];
                let find = 'types.' + (this.index).toString();
                if (findIn == undefined) {
                    return false;
                }
                return findIn.includes(find) || (findIn.includes('Data is invalid') && !this.blocked)
            }
        },
        getError(inputName) {
            if (inputName == 'email') {
                var find = /email.\d/gmiu;
                var re = new RegExp(find, 'g');

                var message = this.errors[`${inputName}`][`${inputName}.${this.index}`][0].replace(re, 'email odbiorcy');
                return message

            }
            return  this.__(
                "alarm_category_required"
            )
        },
    },

    mounted() {
        $('.s2').select2()
    }
}
</script>

<style scoped>

</style>
